// Generated by `npm run tigershark` (scripts/tigershark.ts), from no archive: Maui Nui's tiger sharks on the
// last day of 2025 in the ages their rates settle into, those of 217 cm and longer 498.82,
// Oʻahu's 127 caught in 1967 to 1969 over its 927 km² of shelf times Maui Nui's 3641 (a floor);
// the young's survival a year the one number fitted, so they replace themselves; every other figure a
// source's (src/sim/sharks.ts). Do not edit by hand. tests/tigershark.test.ts holds it to a year's step.
import type { TigerSharkState } from '../../types';

/** The young's survival a year, birth to female maturity, fitted so the sharks replace themselves. */
export const TIGER_SHARK_YOUNG_SURVIVAL = 0.5648073;

/** The factor the sharks grow by a year at their rates, their ages settled. */
export const TIGER_SHARK_GROWTH = 1.0000000;

/** The year whose first of January the table opens. */
export const TIGER_SHARK_TABLE_YEAR = 2026;

/** The sharks on the year before's last day (expected values; a world opening rounds them), by year class since birth. */
export const TIGER_SHARK_TABLE: TigerSharkState = {
  counts: [661.295, 373.504, 210.958, 119.151, 67.2971, 38.8896, 24.0522, 14.8756, 9.2002, 5.69009, 3.51917, 2.17652, 1.34612, 0.83254, 0.514904, 0.318455],
};
